import { STATUS_CONFIG } from '../../config/status';

export const StatusBadge = ({ status }) => (
  <span className={`px-2 py-1 text-xs font-medium rounded-full ${STATUS_CONFIG[status]?.color || 'bg-slate-100'}`}>
    {STATUS_CONFIG[status]?.label || status}
  </span>
);
